import { useState, useEffect } from "react";

// This hook listens for global API/server errors and exposes them for a debug modal
export function useGlobalDebugError() {
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    // Listen for custom events dispatched on window
    function handler(e: CustomEvent) {
      setError(e.detail);
    }
    window.addEventListener("yeschef:global-error", handler as EventListener);
    return () => {
      window.removeEventListener("yeschef:global-error", handler as EventListener);
    };
  }, []);

  function clear() {
    setError(null);
  }

  return { error, clear };
}
